module.exports = __webpack_public_path__ + "static/img/伙伴客户-小米健康.5cbf3d2e.png";